/* I&C redesign: homepage motion layer (November). One IIFE per section; each returns early when its section is absent or reduced motion is on. */

/* ======================= statement ======================= */
/* I&C · motion layer · Statement (rd-statement.liquid)
   Words rise one by one with a blur-to-sharp settle, the gold <em> gets a travelling candle-light sheen,
   a warm glow follows the cursor on desktop, and the link underline draws in last.
   Single IIFE, no globals. Does nothing under prefers-reduced-motion. */
(function () {
  'use strict';
  var MQ_REDUCE = '(prefers-reduced-motion: reduce)';
  var MQ_POINTER = '(hover: hover) and (pointer: fine) and (min-width: 1024px)';
  var WORD = 'rd-m-statement__w';
  var STAGGER = 52, WORD_DUR = 1150, LINK_DUR = 1100, ARM_AT = 0.28;
  var LEADING_PUNCT = /^[,.;:!?’”)\]…]/;

  function init() {
    var section = document.querySelector('.rd .statement');
    if (!section || section.hasAttribute('data-rd-m-statement')) return;
    if (!window.matchMedia || window.matchMedia(MQ_REDUCE).matches) return;
    var p = section.querySelector('p');
    if (!p) return;
    section.setAttribute('data-rd-m-statement', '');

    /* ---- 1. split the sentence into word spans (keeps <em>, <strong>, <a>, <br> intact) ---- */
    var count = 0;
    function makeWord(text, gold) {
      var span = document.createElement('span');
      span.className = WORD + (gold ? ' ' + WORD + '--gold' : '');
      if (gold) {
        /* inner span carries the gradient text so the halo (::before) always sits behind the glyphs */
        var inner = document.createElement('span');
        inner.className = 'rd-m-statement__wt';
        inner.textContent = text;
        span.appendChild(inner);
      } else {
        span.textContent = text;
      }
      return span;
    }
    function splitNode(node, gold) {
      var kids = Array.prototype.slice.call(node.childNodes);
      kids.forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.nodeValue.split(/(\s+)/), frag = document.createDocumentFragment();
          var prev = child.previousSibling, first = true;
          parts.forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); first = false; return; }
            /* punctuation glued to the element before it ("<em>authentic</em>,") shares that word's beat
               and is wrapped with it in a nowrap span so the comma can never start a line on its own */
            if (first && prev && prev.nodeType === 1 && prev.tagName !== 'BR' && count && LEADING_PUNCT.test(part)) {
              var join = makeWord(part, gold);
              join.style.setProperty('--i', count - 1);
              var nb = document.createElement('span');
              nb.className = 'rd-m-statement__nb';
              node.insertBefore(nb, prev);
              nb.appendChild(prev);
              nb.appendChild(join);
              first = false;
              return;
            }
            first = false;
            var span = makeWord(part, gold);
            span.style.setProperty('--i', count++);
            frag.appendChild(span);
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') {
          splitNode(child, gold || child.tagName === 'EM');
        }
      });
    }
    splitNode(p, false);
    if (!count) return;

    /* the link waits for the last word to land */
    var linkDelay = Math.max(0, (count - 1) * STAGGER + WORD_DUR * 0.35);
    section.style.setProperty('--rd-link-delay', linkDelay + 'ms');
    var settleAt = linkDelay + LINK_DUR + 700;

    /* ---- 2. desktop glow + lean (built only where a fine pointer exists) ---- */
    var pointer = window.matchMedia(MQ_POINTER).matches;
    var glow = null, orb = null;
    if (pointer) {
      glow = document.createElement('span');
      glow.className = 'rd-m-statement__glow';
      glow.setAttribute('aria-hidden', 'true');
      orb = document.createElement('span');
      orb.className = 'rd-m-statement__orb';
      glow.appendChild(orb);
      /* the feather overlay fades to whatever the section actually sits on (one-off read, before any loop) */
      var bg = '', el = section;
      while (el && el !== document.documentElement && !bg) {
        var c = window.getComputedStyle(el).backgroundColor;
        if (c && c !== 'transparent' && c !== 'rgba(0, 0, 0, 0)') bg = c;
        el = el.parentElement;
      }
      if (bg) glow.style.setProperty('--rd-m-bg', bg);
      section.insertBefore(glow, section.firstChild);
    }

    section.classList.add('rd-m-statement');

    /* ---- 3. intersection: arm the entrance once at 28 %, keep loops alive while any of it is on screen ---- */
    var onScreen = false, settled = false, armed = false;
    var W = 0, H = 0, pageTop = 0, left = 0;     /* cached geometry; refreshed on resize / IO only */
    var tx = 0, ty = 0, cx = 0, cy = 0;           /* glow target / current, in section px */
    var lx = 0, ly = 0, lcx = 0, lcy = 0;         /* lean target / current */
    var hovering = false, raf = 0, orbSize = 1100;

    function measure(rect) {
      rect = rect || section.getBoundingClientRect();
      W = rect.width; H = rect.height; left = rect.left;
      pageTop = rect.top + (window.pageYOffset || 0);
      orbSize = Math.round(Math.max(700, Math.min(1200, W * 0.72)));
      if (orb) orb.style.setProperty('--rd-orb', orbSize + 'px');
      if (!hovering) { tx = W / 2; ty = H / 2; }
      if (cx === 0 && cy === 0) { cx = tx; cy = ty; paint(); }
    }

    function paint() {
      if (orb) {
        orb.style.setProperty('--rd-gx', cx.toFixed(1) + 'px');
        orb.style.setProperty('--rd-gy', cy.toFixed(1) + 'px');
      }
      if (settled) {
        p.style.setProperty('--rd-px', lcx.toFixed(2) + 'px');
        p.style.setProperty('--rd-py', lcy.toFixed(2) + 'px');
      }
    }

    function tick() {
      raf = 0;
      var k = hovering ? 0.075 : 0.035;               /* weighted: slower drift home than chase */
      cx += (tx - cx) * k; cy += (ty - cy) * k;
      lcx += (lx - lcx) * 0.06; lcy += (ly - lcy) * 0.06;
      paint();
      var moving = Math.abs(tx - cx) + Math.abs(ty - cy) > 0.15 || Math.abs(lx - lcx) + Math.abs(ly - lcy) > 0.02;
      if (moving && onScreen && !document.hidden) raf = requestAnimationFrame(tick);
    }
    function wake() { if (!raf && onScreen && !document.hidden) raf = requestAnimationFrame(tick); }

    function onMove(e) {
      hovering = true;
      var x = e.clientX - left;
      var y = e.clientY - (pageTop - (window.pageYOffset || 0));
      tx = x; ty = y;
      /* lean the sentence a few px toward the cursor */
      lx = ((x / (W || 1)) - 0.5) * 10;
      ly = ((y / (H || 1)) - 0.5) * 6;
      wake();
    }
    function onLeave() { hovering = false; tx = W / 2; ty = H / 2; lx = 0; ly = 0; wake(); }

    function arm(rect) {
      armed = true;
      measure(rect);
      section.classList.add('rd-m-in');
      setTimeout(function () { settled = true; section.classList.add('rd-m-settled'); }, settleAt);
    }

    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        onScreen = en.isIntersecting;
        section.classList.toggle('rd-m-live', onScreen);
        if (!onScreen) return;
        if (!armed && en.intersectionRatio >= ARM_AT) arm(en.boundingClientRect);
        if (armed) wake();
      });
    }, { threshold: [0, ARM_AT], rootMargin: '0px 0px -6% 0px' }) : null;

    if (io) io.observe(section);
    else { onScreen = true; section.classList.add('rd-m-live'); arm(); }

    if (pointer) {
      section.addEventListener('pointermove', onMove, { passive: true });
      section.addEventListener('pointerleave', onLeave, { passive: true });
      var rt = 0;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () { measure(); wake(); }, 120);
      }, { passive: true });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) wake(); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* ======================= edit ======================= */
/* I&C · motion layer · The Edit (rd-edit.liquid + snippets/rd-card.liquid)
   Cards cascade in by column/row as they enter the viewport, breathe while on screen, tilt in 3D under the
   cursor with a candle glow, lift the bottle and lengthen its shadow, and re-cascade on tab switch
   (hooked on the theme's own [data-edit-panel] hidden toggle, so ic-rd.js stays untouched).
   Single IIFE, no globals. Does nothing under prefers-reduced-motion. */
(function () {
  'use strict';
  var MQ_REDUCE = '(prefers-reduced-motion: reduce)';
  var MQ_POINTER = '(hover: hover) and (pointer: fine)';
  var ROW_MS = 150, COL_MS = 85, SWAP_ROW_MS = 110, SWAP_COL_MS = 65;
  var TILT = 6, LERP = 0.14, PERSPECTIVE = 900;
  function toArray(list) { return Array.prototype.slice.call(list); }

  function init() {
    var section = document.querySelector('.rd [data-edit]') || document.querySelector('.rd #rd-edit');
    if (!section || section.hasAttribute('data-rd-m-edit')) return;
    if (!window.matchMedia || window.matchMedia(MQ_REDUCE).matches) return;
    var panels = toArray(section.querySelectorAll('[data-edit-panel], .grid'));
    if (!panels.length) return;
    section.setAttribute('data-rd-m-edit', '');
    section.classList.add('rd-m-edit');

    var fine = window.matchMedia(MQ_POINTER).matches;
    var colCache = []; /* per panel, cleared on resize */

    /* ---- helpers ---- */
    function cardsOf(panel) { return toArray(panel.querySelectorAll('.rd-card')); }
    function colsOf(panel, idx) {
      if (!colCache[idx]) {
        var tpl = window.getComputedStyle(panel).gridTemplateColumns || '';
        colCache[idx] = Math.max(1, tpl.split(' ').filter(function (s) { return s && s.indexOf('repeat') < 0; }).length);
      }
      return colCache[idx];
    }
    function setDelay(card, i, cols, rowMs, colMs, row0) {
      var col = i % cols, row = Math.floor(i / cols);
      card.style.setProperty('--rd-c', String(col));
      card.style.setProperty('--rd-d', Math.round((row - row0) * rowMs + col * colMs) + 'ms');
    }

    /* ---- 1. cascade in per card as it scrolls into view ---- */
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      var batch = [];
      entries.forEach(function (en) { if (en.isIntersecting) { batch.push(en.target); io.unobserve(en.target); } });
      if (!batch.length) return;
      var byPanel = new Map();
      batch.forEach(function (el) {
        if (el.classList.contains('grid-foot')) { el.classList.add('rd-m-in'); return; }
        var panel = el.parentNode, list = byPanel.get(panel);
        if (!list) { list = []; byPanel.set(panel, list); }
        list.push(el);
      });
      byPanel.forEach(function (list, panel) {
        var idx = panels.indexOf(panel), cols = colsOf(panel, idx), all = cardsOf(panel), row0 = Infinity;
        list.forEach(function (c) { row0 = Math.min(row0, Math.floor(all.indexOf(c) / cols)); });
        list.forEach(function (c) { setDelay(c, all.indexOf(c), cols, ROW_MS, COL_MS, row0); c.classList.add('rd-m-in'); });
      });
    }, { rootMargin: '0px', threshold: 0.01 }) : null;

    panels.forEach(function (panel) {
      cardsOf(panel).forEach(function (card) {
        card.style.setProperty('--rd-b', (-(Math.random() * 6)).toFixed(2) + 's');
        if (!panel.hidden) { if (io) io.observe(card); else card.classList.add('rd-m-in'); }
      });
    });
    var foot = section.querySelector('.grid-foot');
    if (foot) { if (io) io.observe(foot); else foot.classList.add('rd-m-in'); }

    /* ---- 2. breath only while the section is on screen and the tab is visible ---- */
    var liveIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { section.classList.toggle('rd-m-live', en.isIntersecting && !document.hidden); });
    }, { rootMargin: '10% 0px' }) : null;
    if (liveIO) liveIO.observe(section); else section.classList.add('rd-m-live');
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) section.classList.remove('rd-m-live');
      else if (liveIO) { liveIO.unobserve(section); liveIO.observe(section); }
    }, { passive: true });

    /* ---- 3. tab switch: when a panel is unhidden its cards cascade again (quicker) ---- */
    var active = null, release = null; /* tilt state, shared with the panel observer so a hidden card is released */
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          var panel = m.target, cards = cardsOf(panel);
          if (panel.hidden) {
            cards.forEach(function (c) { c.classList.remove('rd-m-in', 'rd-m-hover'); if (io) io.unobserve(c); });
            if (release && active && active.parentNode === panel) release();
            return;
          }
          var idx = panels.indexOf(panel);
          window.requestAnimationFrame(function () {
            var cols = colsOf(panel, idx);
            cards.forEach(function (c, i) { setDelay(c, i, cols, SWAP_ROW_MS, SWAP_COL_MS, 0); c.classList.add('rd-m-in'); });
          });
        });
      });
      panels.forEach(function (p) { mo.observe(p, { attributes: true, attributeFilter: ['hidden'] }); });
    }

    /* ---- 4. pointer tilt + candle glow (desktop, fine pointer only) ---- */
    if (fine) {
      var rect = null, raf = 0;
      var cur = { x: 0, y: 0 }, tgt = { x: 0, y: 0 }, mx = 50, my = 40, leaving = false;
      release = function () {
        if (raf) { window.cancelAnimationFrame(raf); raf = 0; }
        if (active) { active.style.transform = ''; active.classList.remove('rd-m-hover'); }
        active = null; rect = null; leaving = false;
      };
      function frame() {
        raf = 0;
        if (!active) return;
        cur.x += (tgt.x - cur.x) * LERP; cur.y += (tgt.y - cur.y) * LERP;
        var settled = Math.abs(tgt.x - cur.x) < 0.02 && Math.abs(tgt.y - cur.y) < 0.02;
        if (settled && leaving) { release(); return; }
        if (settled) { cur.x = tgt.x; cur.y = tgt.y; }
        active.style.transform = 'perspective(' + PERSPECTIVE + 'px) rotateX(' + cur.y.toFixed(2) + 'deg) rotateY(' + cur.x.toFixed(2) + 'deg)';
        active.style.setProperty('--rd-mx', mx.toFixed(1) + '%');
        active.style.setProperty('--rd-my', my.toFixed(1) + '%');
        /* the loop only runs while the card is still moving; pointermove restarts it */
        if (!settled && !document.hidden) raf = window.requestAnimationFrame(frame);
      }
      function tick() { if (!raf && !document.hidden) raf = window.requestAnimationFrame(frame); }
      function enter(e) {
        var card = e.currentTarget;
        if (active && active !== card) release();
        active = card; leaving = false; cur.x = cur.y = 0; tgt.x = tgt.y = 0;
        rect = card.getBoundingClientRect(); /* one layout read per hover (re-read once after a scroll), never inside the loop */
        card.classList.add('rd-m-hover');
        move(e);
      }
      function move(e) {
        if (!active) return;
        if (!rect) { rect = active.getBoundingClientRect(); leaving = false; }
        var px = (e.clientX - rect.left) / rect.width, py = (e.clientY - rect.top) / rect.height;
        px = Math.min(1, Math.max(0, px)); py = Math.min(1, Math.max(0, py));
        /* the side under the cursor leans toward the viewer, like a card held up to a candle */
        tgt.x = (px - 0.5) * 2 * TILT;
        tgt.y = -(py - 0.5) * 2 * TILT;
        mx = px * 100; my = py * 100;
        tick();
      }
      function leave() { if (!active) return; leaving = true; tgt.x = tgt.y = 0; tick(); }
      toArray(section.querySelectorAll('.rd-card')).forEach(function (card) {
        card.addEventListener('pointerenter', enter, { passive: true });
        card.addEventListener('pointermove', move, { passive: true });
        card.addEventListener('pointerleave', leave, { passive: true });
        card.addEventListener('pointercancel', leave, { passive: true });
      });
      /* scrolling under the cursor: settle flat; the next pointermove re-reads the rect and picks the tilt back up */
      window.addEventListener('scroll', function () { if (!active) return; rect = null; leaving = true; tgt.x = tgt.y = 0; tick(); }, { passive: true });
    }

    /* ---- 5. resize: forget cached column counts ---- */
    var rz = 0;
    window.addEventListener('resize', function () {
      if (rz) return;
      rz = window.requestAnimationFrame(function () { rz = 0; colCache = []; });
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();


/* ======================= quiz ======================= */
/* I&C · motion layer · Scent quiz (rd-quiz.liquid)
   The card floats in with a rotateX settle while a thin gold frame draws around it; option buttons are magnetic and get a
   candle-glow pulse in sequence every ~8 s; the question/step crossfade through three real quiz questions every 5 s
   (buttons stay the real first-question buttons; originals are restored before any click); the gold button gets a sheen.
   Single IIFE, no globals. Does nothing under prefers-reduced-motion. Phone: entrance + sheen only. */
(function () {
  'use strict';
  var MQ_REDUCE = '(prefers-reduced-motion: reduce)';
  var MQ_POINTER = '(hover: hover) and (pointer: fine)';
  var MQ_DESK = '(min-width: 901px)';
  var SETTLE = 3400, Q_EVERY = 5000, SWAP = 560, PULSE_EVERY = 8000, PULSE_FIRST = 1400, PULSE_STAGGER = 260, MAG = 6;
  var QUESTIONS = [null, ['Question 2 of 6', 'Who’s it <em>for</em>?'], ['Question 3 of 6', 'Pick a <em>place</em>.']];

  function init() {
    var section = document.querySelector('.rd .quiz-cta');
    if (!section || section.hasAttribute('data-rd-m-quiz')) return;
    if (!window.matchMedia || window.matchMedia(MQ_REDUCE).matches) return;
    var inner = section.querySelector('.quiz-cta__inner');
    var card = section.querySelector('.quiz-cta__card');
    var stepEl = section.querySelector('.quiz-cta__step');
    var qEl = section.querySelector('.quiz-cta__q');
    var opts = Array.prototype.slice.call(section.querySelectorAll('.quiz-cta__opts .quiz__opt'));
    if (!inner || !card || !stepEl || !qEl || !opts.length) return;
    section.setAttribute('data-rd-m-quiz', '');
    var desk = window.matchMedia(MQ_DESK).matches;
    var pointer = desk && window.matchMedia(MQ_POINTER).matches;

    /* ---- stagger indices for the copy column and the options ---- */
    Array.prototype.forEach.call(inner.children, function (col) {
      if (col !== card && col.classList.contains('reveal')) {
        Array.prototype.forEach.call(col.children, function (el, i) { el.style.setProperty('--i', i); });
      }
    });
    opts.forEach(function (o, i) { o.style.setProperty('--i', i); });

    /* ---- gold frame: SVG rect with pathLength=1, drawn by stroke-dashoffset in CSS ---- */
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'rd-m-quiz__frame');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var rect = document.createElementNS(NS, 'rect');
    rect.setAttribute('width', '100%');
    rect.setAttribute('height', '100%');
    rect.setAttribute('pathLength', '1');
    svg.appendChild(rect);
    card.appendChild(svg);

    /* ---- warm halo behind the card (desktop only) ---- */
    if (desk) {
      var halo = document.createElement('span');
      halo.className = 'rd-m-quiz__halo';
      halo.setAttribute('aria-hidden', 'true');
      inner.insertBefore(halo, inner.firstChild);
    }

    section.classList.add('rd-m-quiz');

    /* ---- state ---- */
    var original = [stepEl.innerHTML, qEl.innerHTML];
    var qi = 0, qTimer = 0, swapTimer = 0, pulseTimer = 0, pulseTimers = [];
    var onScreen = false, settled = false, hovered = false, focused = false;

    function running() { return desk && settled && onScreen && !hovered && !focused && !document.hidden; }

    /* question / step crossfade (text only; the buttons never change) */
    function setQ(i) {
      /* the real text stays in the DOM (visually hidden) for assistive tech; the invitation copy is aria-hidden */
      function html(real, show) { return i ? '<span class="rd-m-quiz__sr">' + real + '</span><span aria-hidden="true">' + show + '</span>' : real; }
      stepEl.innerHTML = html(original[0], i ? QUESTIONS[i][0] : '');
      qEl.innerHTML = html(original[1], i ? QUESTIONS[i][1] : '');
      qi = i;
    }
    function unswap() { stepEl.classList.remove('rd-m-swap'); qEl.classList.remove('rd-m-swap'); }
    function stopQ() {
      clearTimeout(qTimer); qTimer = 0;
      if (swapTimer) { clearTimeout(swapTimer); swapTimer = 0; unswap(); }
    }
    function restore() { stopQ(); if (qi !== 0) setQ(0); unswap(); }
    function nextQ() {
      qTimer = 0;
      if (!running()) return;
      stepEl.classList.add('rd-m-swap'); qEl.classList.add('rd-m-swap');
      swapTimer = setTimeout(function () {
        swapTimer = 0;
        setQ((qi + 1) % QUESTIONS.length);
        unswap();
        scheduleQ();
      }, SWAP);
    }
    function scheduleQ() { stopQ(); if (running()) qTimer = setTimeout(nextQ, Q_EVERY); }

    /* candle-glow pulse, one button after another */
    function clearPulse() {
      clearTimeout(pulseTimer); pulseTimer = 0;
      pulseTimers.forEach(clearTimeout); pulseTimers = [];
    }
    function pulse() {
      pulseTimer = 0;
      if (!running()) return;
      opts.forEach(function (o, i) {
        pulseTimers.push(setTimeout(function () { o.classList.add('rd-m-glow'); }, i * PULSE_STAGGER));
      });
      schedulePulse(PULSE_EVERY);
    }
    function schedulePulse(ms) { clearTimeout(pulseTimer); pulseTimer = 0; if (running()) pulseTimer = setTimeout(pulse, ms); }
    opts.forEach(function (o) {
      o.addEventListener('animationend', function () { o.classList.remove('rd-m-glow'); });
    });

    /* one place that starts or stops every loop after a state change */
    function sync(first) {
      if (running()) {
        if (!qTimer && !swapTimer) scheduleQ();
        if (!pulseTimer) schedulePulse(first ? PULSE_FIRST : PULSE_EVERY);
      } else {
        stopQ();
        clearPulse();
      }
    }

    /* ---- entrance: on screen -> rd-m-in; a while later -> rd-m-settled ---- */
    function enter() {
      if (section.classList.contains('rd-m-in')) return;
      window.removeEventListener('scroll', onScroll);
      section.classList.add('rd-m-in');
      setTimeout(function () {
        settled = true;
        section.classList.add('rd-m-settled');
        sync(true);
      }, SETTLE);
    }
    var scrollTick = false;
    function onScroll() {
      if (scrollTick) return;
      scrollTick = true;
      requestAnimationFrame(function () {
        scrollTick = false;
        if (!section.classList.contains('rd-m-in') && section.getBoundingClientRect().bottom < 0) enter();
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          onScreen = en.isIntersecting;
          section.classList.toggle('rd-m-on', onScreen);
          if (onScreen && (en.intersectionRatio >= 0.18 || en.boundingClientRect.top < window.innerHeight * 0.55)) enter();
          else if (!onScreen && en.boundingClientRect.bottom < 0) enter(); /* already scrolled past: never leave it hidden */
          sync();
        });
      }, { threshold: [0, 0.18], rootMargin: '0px 0px -6% 0px' });
      io.observe(section);
      /* a jump that skips the section in one frame (anchor link, fast fling) crosses no IO threshold:
         until the entrance has started, one rAF-throttled rect read per scroll catches it; removed in enter() */
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      onScreen = true;
      section.classList.add('rd-m-on');
      enter();
    }
    document.addEventListener('visibilitychange', function () { sync(); });

    /* ---- the invitation stops (and shows the real first question) as soon as the visitor engages ---- */
    function hold() { restore(); sync(); }
    function release() { sync(); }
    section.addEventListener('pointerdown', restore, true);
    section.addEventListener('click', restore, true);
    section.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') restore(); }, true);
    card.addEventListener('focusin', function () { focused = true; hold(); });
    card.addEventListener('focusout', function (e) { if (!e.relatedTarget || !card.contains(e.relatedTarget)) { focused = false; release(); } });

    /* ---- desktop pointer: magnetic options, light inside the button, candle-light across the card ---- */
    if (pointer) {
      var cr = null;
      card.addEventListener('pointerenter', function () {
        cr = card.getBoundingClientRect();
        card.classList.add('rd-m-lit');
        hovered = true;
        hold();
      });
      card.addEventListener('pointermove', function (e) {
        if (!cr) return;
        card.style.setProperty('--cx', ((e.clientX - cr.left) / cr.width * 100).toFixed(1) + '%');
        card.style.setProperty('--cy', ((e.clientY - cr.top) / cr.height * 100).toFixed(1) + '%');
      }, { passive: true });
      card.addEventListener('pointerleave', function () {
        cr = null;
        card.classList.remove('rd-m-lit');
        hovered = false;
        release();
      });

      opts.forEach(function (o) {
        var r = null;
        o.addEventListener('pointerenter', function () {
          if (!settled) return;
          r = o.getBoundingClientRect();
          o.classList.add('rd-m-mag');
        });
        o.addEventListener('pointermove', function (e) {
          if (!r) return;
          var dx = Math.max(-1, Math.min(1, (e.clientX - r.left - r.width / 2) / (r.width / 2)));
          var dy = Math.max(-1, Math.min(1, (e.clientY - r.top - r.height / 2) / (r.height / 2)));
          o.style.setProperty('--mx', (dx * MAG).toFixed(2) + 'px');
          o.style.setProperty('--my', (dy * MAG).toFixed(2) + 'px');
          o.style.setProperty('--lx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
          o.style.setProperty('--ly', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        }, { passive: true });
        o.addEventListener('pointerleave', function () {
          r = null;
          o.classList.remove('rd-m-mag');
          o.style.setProperty('--mx', '0px');
          o.style.setProperty('--my', '0px');
        });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
